import { render, staticRenderFns } from "./VersionTip.vue?vue&type=template&id=eb6641ca&scoped=true"
import script from "./VersionTip.vue?vue&type=script&lang=js"
export * from "./VersionTip.vue?vue&type=script&lang=js"
import style0 from "./VersionTip.vue?vue&type=style&index=0&id=eb6641ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6641ca",
  null
  
)

export default component.exports